import axios from "../axios-auth";
import orginal_axios from "axios";

export const trialBalanceService = {
    getTrialBalanceList,
    saveTrialBalance,
    getTrialBalanceById,
    getTrialBalanceDetailFromLedger,
    confirmTrialBalane,
    exportTrialBalanceById,
    getCashTrialBalance,
    exportCashTrialBalance,
};

function getTrialBalanceDetailFromLedger(searchParams) {
    let params = {};
    if (searchParams.yearAndMonth) {
        params["yearAndMonth"] = searchParams.yearAndMonth;
    }
    if (searchParams.shopCode) {
        params["shopCode"] = searchParams.shopCode;
    }
    if (searchParams.trialBalanceType) {
        params["trialBalanceType"] = searchParams.trialBalanceType;
    }
    return axios.get("/auth/trial-balance-detail-account", { params });
}

function getTrialBalanceList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.trialBalanceCode) {
        params["trialBalanceCode"] = searchParams.trialBalanceCode;
    }
    if (searchParams.shopCode) {
        params["shopCode"] = searchParams.shopCode;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/trial-balances", { params });
}

function saveTrialBalance(trialBalance) {
    if (!trialBalance.id) {
        // new trial balance
        return axios.post("/auth/trial-balance", trialBalance);
    }
}

function getTrialBalanceById(id) {
    return axios.get("/auth/trial-balance/" + id);
}

function confirmTrialBalane(id) {
    return axios.get("/auth/confirm-trial-balance/" + id);
}

function exportTrialBalanceById(id){
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/trial-balance-excel/"+id,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getCashTrialBalance(searchParams) {
    let params = {};
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.trialBalanceType) {
        params["trialBalanceType"] = searchParams.trialBalanceType;
    }
    return axios.get("/auth/cash-trial-detail", { params });
}

function exportCashTrialBalance(searchParams) {
    let params = {};
    if (searchParams.fromMonth) {
        params["fromMonth"] = searchParams.fromMonth;
    }
    if (searchParams.toMonth) {
        params["toMonth"] = searchParams.toMonth;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.trialBalanceType) {
        params["trialBalanceType"] = searchParams.trialBalanceType;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/cash-trial-detail-excel", params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}